<template>
  <div class="row company">
        <div class="col">
        <div class="row clients-actions">
            <div class="col">
            <form class="form-inline py-2 justify-content-between" @submit.prevent>
                <router-link to="/clients/company/create">
                    <button type="button" class="btn btn-primary">
                         <i class="ico ico-plus mr-2"></i>
                         Добавить юр лицо
                    </button>
                </router-link>
                <div class="input-group with-clear-icon">
                <input type="text" class="form-control" v-model="searchText">
                <i class="ico ico-close" @click="clearSearchText" v-if="searchText.length > 0"></i>
                <div class="input-group-append">
                    <span class="input-group-text">
                    <i class="fa fa-search"></i>
                    </span>
                </div>
                </div>
            </form>
            </div>
        </div>
        <div class="row my-4">
            <div class="col">
            <div class="row table-row">
                <div class="col">
                <table class="table companies-table">
                    <thead>
                    <tr>
                        <th v-for="item in tableHeaderItems" :key="item.name" v-show="item.isVisible" :style="{'width': item.width * 100 / tableHeaderItems.map(x=>x.width).reduce((a, b) => a + b) + '%'}">
                            <div class="table-th">{{ item.viewName }}</div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="company in filteredCompanies" :key="company.id">
                        <td>
                            <div class="td-content" :title="company.name">{{company.name}}</div>
                        </td>
                        <td>
                            <div class="td-content" :title="company.email">{{company.email}}</div>
                        </td>
                        <td>
                            <div class="td-content" :title="company.phone">{{company.phone}}</div>
                        </td>
                        <td>
                            <div class="td-content td-content-lg" :title="company.address">{{company.address}}</div>
                        </td>
                        <td>
                            <div class="td-content td-content-lg" :title="company.description">{{company.description}}</div>
                        </td>
                        <td align="center" v-show="isUserCanEditClients">
                            <router-link :to="`/clients/company/edit/${company.id}`">
                                <button type="button" class="btn btn-sm btn-primary px-3">
                                    <i class="fa fa-pencil"></i>
                                </button>
                            </router-link>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import api from '../../../api'
import roles from '../../../helpers/userRoles'

const mapCompany = company => {
  return {
    id: company.id,
    name: company.name,
    address: company.address,
    email: company.email,
    phone: company.telephone,
    description: company.description
  }
}

export default {
  name: 'Company',
  data: () => {
    return {
      companies: [],
      searchText: '',
      tableHeaderItems: []
    }
  },
  methods: {
    loadCompanies () {
      api.get
        .companies()
        .then(resp => {
          this.companies = resp.data.data.legalEntities
            .map(mapCompany)
            .sort(function (a, b) {
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1
              }
              return 0
            })
          this.searchText = ''
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    setTableHeader () {
      this.tableHeaderItems = [
        {
          name: 'name',
          viewName: 'Название',
          width: 175,
          isVisible: true
        },
        {
          name: 'email',
          viewName: this.$t('home.email'),
          width: 150,
          isVisible: true
        },
        {
          name: 'phone',
          viewName: this.$t('home.phone'),
          width: 150,
          isVisible: true
        },
        {
          name: 'address',
          viewName: 'Адресс',
          width: 200,
          isVisible: true
        },
        {
          name: 'description',
          viewName: this.$t('home.description'),
          width: 200,
          isVisible: true
        },
        {
          name: 'actions',
          viewName: '',
          width: 125,
          isVisible: this.isUserCanEditClients
        }
      ]
    },
    clearSearchText () {
      this.searchText = ''
    }
  },
  computed: {
    filteredCompanies () {
      if (!this.searchText) {
        return this.companies
      }

      return this.companies.filter(x => {
        return Object.keys(x)
          .map(key => x[key])
          .filter(x => x)
          .some(
            y =>
              y
                .toString()
                .toLowerCase()
                .indexOf(this.searchText.toLowerCase()) > -1
          )
      })
    },
    isUserCanEditClients () {
      return (
        this.$store.getters.role === roles.manager ||
        this.$store.getters.role === roles.director
      )
    }
  },
  created: function () {
    this.loadCompanies()
    this.setTableHeader()
  }
}
</script>

<style lang="scss" scoped>

</style>
